import React from 'react';
import { Row, Col } from 'antd';
import { formatDateTime } from '../../utils/format';
import MonitorCard from '../../components/MonitorCard';
import {
  fetchPendingIncomes,
  fetchStalledIncomes,
  fetchPendingBatchSweeps,
  fetchStalledBatchSweeps,
  fetchPendingTransfers
} from '../../services/monitorService';
import './style.css';

const Monitor = () => {
  // Column definitions
  const incomeColumns = [
    { title: '链', dataIndex: 'chain', key: 'chain' },
    { title: '资产', dataIndex: 'symbol', key: 'symbol' },
    { title: '地址', dataIndex: 'address', key: 'address', ellipsis: false },
    { title: '数量', dataIndex: 'amount', key: 'amount' },
    { title: '状态', dataIndex: 'state', key: 'state' },
    { title: '创建时间', dataIndex: 'inserted_at', key: 'inserted_at', render: (d) => formatDateTime(d) },
  ];

  const stalledIncomeColumns = [
    ...incomeColumns,
    { title: 'TXID', dataIndex: 'txid', key: 'txid', ellipsis: false },
    { title: '状态', dataIndex: 'status', key: 'status' },
  ];

  const sweepColumns = [
    { title: '链', dataIndex: 'chain', key: 'chain' },
    { title: '资产', dataIndex: 'symbol', key: 'symbol' },
    { title: '地址', dataIndex: 'address', key: 'address', ellipsis: false },
    { title: '状态', dataIndex: 'state', key: 'state' },
    { title: '创建时间', dataIndex: 'inserted_at', key: 'inserted_at', render: (d) => formatDateTime(d) },
  ];

  const stalledSweepColumns = [
    ...sweepColumns,
    { title: 'TXID', dataIndex: 'txid', key: 'txid', ellipsis: false },
    { title: '状态', dataIndex: 'status', key: 'status' },
  ];

  const transferColumns = [
    { title: '链', dataIndex: 'chain', key: 'chain' },
    { title: '资产', dataIndex: 'symbol', key: 'symbol' },
    { title: '数量', dataIndex: 'amount', key: 'amount' },
    { title: '状态', dataIndex: 'state', key: 'state' },
    { title: 'TXID', dataIndex: 'txid', key: 'txid', ellipsis: false },
    { title: '创建时间', dataIndex: 'inserted_at', key: 'inserted_at', render: (d) => formatDateTime(d) },
  ];

  return (
    <div className="monitor-container">
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <MonitorCard
            title="未达最终态的充值"
            columns={incomeColumns}
            fetchFunction={fetchPendingIncomes}
          />
        </Col>
        <Col xs={24} md={12}>
          <MonitorCard
            title="超过6小时未成功的充值"
            columns={stalledIncomeColumns}
            fetchFunction={fetchStalledIncomes}
          />
        </Col>
        <Col xs={24} md={12}>
          <MonitorCard
            title="未达最终态的批量归集"
            columns={sweepColumns}
            fetchFunction={fetchPendingBatchSweeps}
          />
        </Col>
        <Col xs={24} md={12}>
          <MonitorCard
            title="归集超过6小时未成功的批量归集"
            columns={stalledSweepColumns}
            fetchFunction={fetchStalledBatchSweeps}
          />
        </Col>
        <Col xs={24}>
          <MonitorCard
            title="未达最终态的提现"
            columns={transferColumns}
            fetchFunction={fetchPendingTransfers}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Monitor;